module.exports = {
    TenantCollection: "TenantCollection",
    UserAccountId: "UserAccountId"
};
